/**
 * This file maintains the running list of experiments that this application cares about.
 * This can be both via Optimizely and internal AB.
 * Sample experiment information:
 * export const TEST_NAME = {
 *  name: 'test_name_in_taproom',
 *  variant: 'variant_name_in_taproom'
 * };
 */

export default [];
